/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/destructuring-assignment */
import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { v4 as uuidv4 } from 'uuid';
import {
  Loader, Checkbox, Modal, Label, Popup, Icon, List, Segment, Dimmer
} from 'semantic-ui-react';
import $ from 'jquery';
import { withTranslation } from 'react-i18next';
import WithRouter from '../Extensions/WithRouter';
import SettingContentsHeader from './SettingContentsHeader';
import ChangeStatusProject from '../Modal/ChangeStatusProject';
import NewUserModal from '../Modal/NewUserModal';
import EditUserModal from '../Modal/EditUserModal';
import DeleteProjectModal from '../Modal/DeleteProjectModal';
import userPic from '../../images/common/profile_icon_big.png';
import api from '../../api';
import downIcon from '../../images/components/content_wide_card/headerSorting (down).png';
import upIcon from '../../images/components/content_wide_card/headerSorting (up).png';
import AssigningProjectModal from '../Modal/AssigningProjectModal';

class UserSetting extends Component {
  constructor(props) {
    super(props);
    this.userSetting = React.createRef();
    this.state = {
      isOpen: false,
      isOpenMAP: false,
      isOpenMCS: false,
      isOpenMEU: false,
      isOpenMDP: false,
      isOpenMCU: false,
      isPageLoading: false,
      pageSize: 10,
      currentPage: 1,
      userList: [],
      checkValue: [],
      filter: [],
      selectedList: [],
      versionList: [],
      isSort: false,
      sortColumn: '2',
      error: null,
      hasMore: true,
      isLoading: false,
      isNextLoading: false,
      isDisableStatus: false,
      isDisableDelete: false,
      versionPopup: false,
      activeIndex: '',
    };

    this.handleOnScroll = this.handleOnScroll.bind(this);
    this.handleCheckChange = this.handleCheckChange.bind(this);
    this.handleMAPOpen = this.handleMAPOpen.bind(this);
    this.handleMAPClose = this.handleMAPClose.bind(this);
    this.handleMCSOpen = this.handleMCSOpen.bind(this);
    this.handleMCSClose = this.handleMCSClose.bind(this);
    this.handleMEUOpen = this.handleMEUOpen.bind(this);
    this.handleMEUClose = this.handleMEUClose.bind(this);
    this.handleMDUOpen = this.handleMDUOpen.bind(this);
    this.handleMDUClose = this.handleMDUClose.bind(this);
    this.handleMCUOpen = this.handleMCUOpen.bind(this);
    this.handleMCUClose = this.handleMCUClose.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleFilterData = this.handleFilterData.bind(this);
    this.handleSearchChange = this.handleSearchChange.bind(this);
    this.handleCompleteCallback = this.handleCompleteCallback.bind(this);
    this.handleUserCheckAll = this.handleUserCheckAll.bind(this);
    this.onChangeSorting = this.onChangeSorting.bind(this);
    this.closeErrorModal = this.closeErrorModal.bind(this);
    this.clearValue = this.clearValue.bind(this);
    this.clearAllValue = this.clearAllValue.bind(this);
    this.clearSearch = this.clearSearch.bind(this);
  }

  componentDidMount() {
    window.addEventListener('scroll', this.handleOnScroll);
    if (this.userSetting) {
      this.onUpdateLoading();
    }
    const $contentsHeader = $('.contents_header');
    const $tableHeader = $('.setting_table_header');
    const $window = $(window);

    $window.on('scroll.contents_header', () => {
      if ($window.scrollTop() > 0) {
        $contentsHeader.addClass('fixed');
        $tableHeader.addClass('fixed');
      } else {
        $contentsHeader.removeClass('fixed');
        $tableHeader.removeClass('fixed');
      }
    });

    $(document).on(
      'mouseover',
      '.setting_project_content .project_name .content_wrapper',
      function () {
        const $this = $(this);
        if (this.offsetWidth < this.scrollWidth && !$this.attr('title')) {
          $this.attr('title', $this.text());
        }
      }
    );
  }

  componentDidUpdate(prevProps, prevState) {
    const { isPageLoading } = this.state;
    if (prevState.isOpenMAP !== this.state.isOpenMAP || prevState.isOpenMEU !== this.state.isOpenMEU || prevState.isOpenMDP !== this.state.isOpenMDP || prevState.isOpen !== this.state.isOpen || prevState.isOpenMCS !== this.state.isOpenMCS || prevState.isOpenMCU !== this.state.isOpenMCU) {
      this.handleClose();
    }

    if (prevState.isPageLoading !== isPageLoading && isPageLoading) {
      this.getLocalUserList();
      this.setState({
        isPageLoading: false,
      });
    }
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleOnScroll);
  }

  handleCheckChange(e, { value }) {
    const { checkValue, userList } = this.state;
    let newState;

    if (checkValue.indexOf(value) > -1) {
      newState = checkValue.filter((el) => {
        return el !== value;
      });
    } else {
      newState = [...checkValue, value];
    }

    const newUserArr = userList.filter((item) => {
      return newState.indexOf(item.uid) > -1;
    });

    const checkAuthStatus = newUserArr.filter((item) => {
      return item.isStateChange === false;
    });

    const checkAuthDelete = newUserArr.filter((item) => {
      return item.isDelete === false;
    });

    if (checkAuthStatus.length !== 0) {
      this.setState({
        isDisableStatus: true,
      });
    } else {
      this.setState({
        isDisableStatus: false,
      });
    }

    if (checkAuthDelete.length !== 0) {
      this.setState({
        isDisableDelete: true,
      });
    } else {
      this.setState({
        isDisableDelete: false,
      });
    }

    if (newState.length !== 0 && newState.length !== userList.length) {
      this.setState({
        checkValue: newState,
        itemsChecked: false,
      });
    } else {
      this.setState({
        checkValue: newState,
      });
    }
  }

  handleUserCheckAll() {
    const { itemsChecked, userList } = this.state;
    const newState = [];

    if (itemsChecked) {
      this.setState({
        itemsChecked: false,
        isDisableStatus: false,
        isDisableDelete: false,
        checkValue: [],
      });
    } else {
      const checkAuthStatus = userList.filter((item) => {
        return item.isStateChange === false;
      });

      const checkAuthDelete = userList.filter((item) => {
        return item.isDelete === false;
      });

      if (checkAuthStatus.length !== 0) {
        this.setState({
          isDisableStatus: true,
        });
      } else {
        this.setState({
          isDisableStatus: false,
        });
      }

      if (checkAuthDelete.length !== 0) {
        this.setState({
          isDisableDelete: true,
        });
      } else {
        this.setState({
          isDisableDelete: false,
        });
      }

      const num = userList.length;
      let i = 0;
      for (i; i < num; i++) {
        newState.push(userList[i].uid);
      }

      const unique = newState.reduce((a, b) => {
        if (a.indexOf(b) < 0) {
          a.push(b);
        }
        return a;
      }, []);
      this.setState({
        itemsChecked: true,
        checkValue: unique,
      });
    }
  }

  handleOnScroll() {
    const {
      getLocalUserList,
      state: { error, isNextLoading, hasMore },
    } = this;
    const scrollHeight = Math.max(
      document.documentElement.scrollHeight,
      document.body.scrollHeight
    );
    const scrollTop = Math.max(document.documentElement.scrollTop, document.body.scrollTop);
    const { clientHeight } = document.documentElement;

    if (error || isNextLoading || !hasMore) {
      return;
    }

    if (scrollTop + clientHeight >= scrollHeight) {
      getLocalUserList(this.state.currentPage + 1);
    }
  }

  handleMDUOpen() {
    const { checkValue } = this.state;

    if (checkValue.length === 0) {
      this.setState({
        isOpen: true,
      });
    } else {
      this.setState({
        isOpenMDP: true,
      });
    }
  }

  handleSearchChange(value) {
    this.setState(
      {
        searchKeyword: value,
        userList: [],
      },
      () => {
        this.getLocalUserList();
      }
    );
  }

  handleFilterData(value) {
    this.setState(
      {
        userList: [],
        filter: value.filter,
      },
      () => {
        this.getLocalUserList();
      }
    );
  }

  handleCompleteCallback(statusCode) {
    if (statusCode) {
      this.setState(
        {
          userList: [],
          checkValue: [],
          itemsChecked: false,
        },
        () => {
          this.getLocalUserList();
        }
      );
    } else {
      console.log('failed to save');
    }
  }

  handleMAPOpen() {
    const { checkValue, userList } = this.state;

    const selectedArr = userList.filter((item) => {
      return checkValue.indexOf(item.uid) > -1;
    });

    if (checkValue.length === 0) {
      this.setState({
        isOpen: true,
      });
      return false;
    }

    this.setState({
      isOpenMAP: true,
      selectedList: selectedArr,
    });
  }

  handleMCSOpen() {
    const { checkValue, userList } = this.state;

    const selectedArr = userList.filter((item) => {
      return checkValue.indexOf(item.uid) > -1;
    });

    if (checkValue.length === 0) {
      this.setState({
        isOpen: true,
      });
      return false;
    }

    this.setState({
      isOpenMCS: true,
      selectedList: selectedArr,
    });
  }

  handleMAPClose() {
    this.setState({
      isOpenMAP: false,
    });
  }

  handleMCSClose() {
    this.setState({
      isOpenMCS: false,
    });
  }

  handleMEUOpen(userId) {
    this.setState({
      isOpenMEU: true,
      selectedUserId: userId,
    });
  }

  handleMEUClose() {
    this.setState({
      isOpenMEU: false,
    });
  }

  handleMDUClose() {
    this.setState(
      {
        userList: [],
        isOpenMDP: false,
      },
      () => {
        this.getLocalUserList();
      }
    );
  }

  handleMCUOpen() {
    this.setState({
      isOpenMCU: true,
    });
  }

  handleMCUClose() {
    this.setState({
      isOpenMCU: false,
    });
  }

  handleClose() {
    this.setState({
      versionPopup: false,
      activeIndex: '',
    });
  }

  onUpdateLoading() {
    this.setState({
      isPageLoading: true,
    });
  }

  onChangeSorting = (e) => {
    const { isSort } = this.state;
    if (e.currentTarget.dataset.id !== this.state.sortColumn) {
      this.setState(
        {
          sortColumn: e.currentTarget.dataset.id,
          isSort: false,
          userList: [],
          activeIndex: [],
        },
        () => {
          this.getLocalUserList();
        }
      );
    } else {
      this.setState(
        {
          sortColumn: e.currentTarget.dataset.id,
          isSort: !isSort,
          userList: [],
          activeIndex: [],
        },
        () => {
          this.getLocalUserList();
        }
      );
    }
  };

  getProfileImg(value) {
    const profileImg = `/1/users/me/profile_image/${value}`;

    let baseUrl = '//'.concat(location.hostname);
    let profileImgUrl = '';

    if (process.env.NODE_ENV === 'development') {
      baseUrl = baseUrl.concat(':3000');
    } else {
      baseUrl = location.port !== '' ? baseUrl.concat(':', location.port) : '';
    }

    profileImgUrl = profileImg !== '' ? baseUrl.concat(profileImg) : userPic;

    return (
      <img
        src={profileImgUrl}
        alt="profile"
        style={{
          width: '17px', height: '17px', borderRadius: '50%', marginRight: '5px'
        }}
      />
    );
  }

  getSProjectVersionDetail = (userId) => {
    const { t } = this.props;
    api
      .getSProjectCountDetail(userId)
      .then((response) => {
        const data = response.response;
        this.setState({
          activeIndex: userId,
          versionPopup: true,
          versionList: data.project_list,
        });
      })
      .catch((err) => {
        console.log(err);
        this.setState({
          error: t('modal.error.error_load'),
          isLoading: false,
        });
      });
  };

  getLocalUserList = (pageNo, limit) => {
    let filterData;
    let text;
    const {
      isSort, sortColumn, filter, pageSize, userList
    } = this.state;
    const { t } = this.props;
    const page = pageNo || 1;
    const perPage = limit || pageSize;

    if (filter.length !== 0) {
      let i = 0;
      for (i; i < filter.length; i++) {
        if (i === 0) {
          filterData = filter[i];
        } else {
          filterData = `${filterData},${filter[i]}`;
        }
      }
    } else {
      filterData = '';
    }

    switch (true) {
    case sortColumn === '1':
      if (isSort) {
        text = 'source';
      } else {
        text = 'source_r';
      }
      break;
    case sortColumn === '2':
      if (isSort) {
        text = 'name';
      } else {
        text = 'name_r';
      }
      break;
    case sortColumn === '3':
      if (isSort) {
        text = 'email';
      } else {
        text = 'email_r';
      }
      break;
    case sortColumn === '4':
      if (isSort) {
        text = 'permission_r';
      } else {
        text = 'permission';
      }
      break;
    case sortColumn === '5' && this.props.state.user.isSuperAdmin:
      if (isSort) {
        text = 'company_r';
      } else {
        text = 'company';
      }
      break;
    case sortColumn === '5' && !this.props.state.user.isSuperAdmin:
      if (isSort) {
        text = 'project_r';
      } else {
        text = 'project';
      }
      break;
    case sortColumn === '6':
      if (isSort) {
        text = 'modified_r';
      } else {
        text = 'modified';
      }
      break;
    case sortColumn === '7':
      if (isSort) {
        text = 'accessed_r';
      } else {
        text = 'accessed';
      }
      break;
    case sortColumn === '8':
      if (isSort) {
        text = 'status';
      } else {
        text = 'status_r';
      }
      break;
    case sortColumn === '9':
      if (isSort) {
        text = 'ldap';
      } else {
        text = 'ldap_r';
      }
      break;
    default:
      text = 'modified';
      break;
    }

    if (page === 1) {
      this.setState({
        isLoading: true,
      });
    } else {
      this.setState({
        isNextLoading: true,
      });
    }
    api
      .getCompanyUsers(
        {
          search: this.state.searchKeyword,
          page,
          limit: perPage,
          order: text,
          filter: filterData,
        }
      )
      .then((response) => {
        if (this.state.userList.length !== 0 && response.pagination.current === 1) {
          return false;
        }
        const nextUserList = response.response.map((item) => {
          return {
            uid: item.id,
            source: item.source,
            userName: item.user_name,
            email: item.email,
            permission: item.permission,
            projectCount: item.project_count,
            companyName: item.user_company_name,
            lastModified: item.last_modified,
            lastAccessed: item.last_accessed,
            ldapName: item.ldap_name,
            status: item.status,
            isAdd: item.is_addable,
            isProjectAssign: item.is_project_assignable,
            isStateChange: item.is_state_changeable,
            isDelete: item.is_deletable,
          };
        });
        this.setState({
          currentCount: response.pagination.count,
          pageSize: response.pagination.per_page,
          //totalPage: response.pagination.pages,
          currentPage: response.pagination.current,
          //totalCount: response.count,
          //prevPage: response.pagination.previous,
          //nextPage: response.pagination.next,
          hasMore: response.count === pageSize,
          isLoading: false,
          isNextLoading: false,
          userList: page === 1 ? nextUserList : [...userList, ...nextUserList],
        });
      })
      .catch((err) => {
        console.log(err);
        this.setState({
          error: t('modal.error.error_load'),
          isLoading: false,
          isNextLoading: false,
        });
      });
  };

  clearValue = (tagValue) => {
    const { filter } = this.state;
    let newState;
    if (filter.indexOf(tagValue) > -1) {
      newState = filter.filter((el) => {
        return el !== tagValue;
      });
    } else {
      newState = [];
    }
    this.setState(
      {
        userList: [],
        filter: newState,
      },
      () => {
        this.getLocalUserList();
      }
    );
  };

  clearAllValue = () => {
    this.setState(
      {
        userList: [],
        filter: [],
      },
      () => {
        this.getLocalUserList();
      }
    );
  };

  closeErrorModal() {
    this.setState({
      isOpen: false,
    });
  }

  convertToString(string) {
    if (string === 'clarityadmin@insignary.com') {
      return 'Admin';
    } if (string === 'licensemanager@insignary.com') {
      return 'Licensemanager';
    }
    return string;
  }

  clearSearch() {
    this.setState(
      {
        searchKeyword: '',
        userList: [],
      },
      () => {
        this.getLocalUserList();
      }
    );
  }

  renderValue() {
    const { filter } = this.state;
    const { t } = this.props;

    const sourceFilter = filter.filter((item) => {
      return item.indexOf('source') > -1;
    });

    const permFilter = filter.filter((item) => {
      return item.indexOf('permission') > -1;
    });

    const statusFilter = filter.filter((item) => {
      return item.indexOf('status') > -1;
    });

    const filterObj = {
      source: sourceFilter,
      permission: permFilter,
      status: statusFilter,
    };

    return (
      <div>
        {filterObj.source.length !== 0 && (
          <Label.Group>
            <span>
              <strong>{t('settings.list.type')}</strong>
            </span>
            {filterObj.source.map((item) => {
              return (
                <Label as="a" key={uuidv4()}>
                  {item.indexOf('_local') > -1 && t('modal.title.local')}
                  {item.indexOf('_ldap') > -1 && t('modal.title.ldap')}
                  <Icon
                    name="close"
                    onClick={() => {
                      return this.clearValue(item.toString());
                    }}
                  />
                </Label>
              );
            })}
          </Label.Group>
        )}

        {filterObj.permission.length !== 0 && (
          <Label.Group>
            <span>
              <strong>{t('settings.list.permission')}</strong>
            </span>
            {filterObj.permission.map((item) => {
              return (
                <Label as="a" key={uuidv4()}>
                  {item.indexOf('_user') > -1 && t('settings.list.user')}
                  {item.indexOf('_admin') > -1 && t('settings.list.admin')}
                  <Icon
                    name="close"
                    onClick={() => {
                      return this.clearValue(item.toString());
                    }}
                  />
                </Label>
              );
            })}
          </Label.Group>
        )}

        {filterObj.status.length !== 0 && (
          <Label.Group>
            <span>
              <strong>{t('settings.list.status')}</strong>
            </span>
            {filterObj.status.map((item) => {
              return (
                <Label as="a" key={uuidv4()}>
                  {item.indexOf('_active') > -1 && t('modal.title.active')}
                  {item.indexOf('_inactive') > -1 && t('modal.title.inactive')}
                  <Icon
                    name="close"
                    onClick={() => {
                      return this.clearValue(item.toString());
                    }}
                  />
                </Label>
              );
            })}
          </Label.Group>
        )}

        {filter.length !== 0 ? (
          <div
            className="clear_all"
            onClick={() => {
              return this.clearAllValue();
            }}
          >
            {t('project.menu.clear_all_filters')}
          </div>
        ) : null}
      </div>
    );
  }

  render() {
    const {
      userList,
      checkValue,
      error,
      isLoading,
      isNextLoading,
      currentCount,
      isSort,
      sortColumn,
      filter,
      activeIndex,
      itemsChecked,
    } = this.state;
    const { location, state, t } = this.props;
    const pathname = location.pathname ? location.pathname : location;

    return (
      <div className="setting_user" ref={this.userSetting}>
        <SettingContentsHeader
          userCount={currentCount}
          deleteProject={this.handleMDUOpen}
          changeStatus={this.handleMCSOpen}
          assignProject={this.handleMAPOpen}
          addNewUser={this.handleMCUOpen}
          onSubmit={this.handleFilterData}
          clearSearch={this.clearSearch}
          onChangeSearch={this.handleSearchChange}
          isDisableStatus={this.state.isDisableStatus}
          isDisableDelete={this.state.isDisableDelete}
          filter={filter}
          location={pathname}
          state={state}
          translate={t}
        />
        <div className="setting_project_content">
          {filter.length !== 0 ? <div className="tag_list">{this.renderValue()}</div> : ''}
          <div className="setting_table_header">
            <div className="setting_table_header_inner">
              <table className="setting_project_table table_header">
                <colgroup>
                  <col style={{ width: '36px' }} />
                  <col style={{ width: '7%' }} />
                  <col style={{ width: '13%' }} />
                  <col style={{ width: '13%' }} />
                  <col style={{ width: '8%' }} />
                  <col style={{ width: '8%' }} />
                  <col style={{ width: '11%' }} />
                  <col style={{ width: '11%' }} />
                  <col style={{ width: '11%' }} />
                  <col style={{ width: '8%' }} />
                  <col style={{ width: '' }} />
                </colgroup>
                <thead>
                  <tr>
                    <th>
                      <Checkbox checked={itemsChecked} onChange={this.handleUserCheckAll} />
                    </th>
                    <th>
                      <a className="sorting_button" data-id="1" onClick={this.onChangeSorting}>
                        {t('settings.list.type')}
                        {isSort && sortColumn === '1' ? <img src={upIcon} alt="" /> : ''}
                        {!isSort && sortColumn === '1' ? <img src={downIcon} alt="" /> : ''}
                      </a>
                    </th>
                    <th className="project_name">
                      <a className="sorting_button" data-id="2" onClick={this.onChangeSorting}>
                        {t('settings.list.user_name')}
                        {isSort && sortColumn === '2' ? <img src={upIcon} alt="" /> : ''}
                        {!isSort && sortColumn === '2' ? <img src={downIcon} alt="" /> : ''}
                      </a>
                    </th>
                    <th className="project_name">
                      <a className="sorting_button" data-id="3" onClick={this.onChangeSorting}>
                        {t('settings.list.email')}
                        {isSort && sortColumn === '3' ? <img src={upIcon} alt="" /> : ''}
                        {!isSort && sortColumn === '3' ? <img src={downIcon} alt="" /> : ''}
                      </a>
                    </th>
                    <th className="owner">
                      <a className="sorting_button" data-id="4" onClick={this.onChangeSorting}>
                        <span>
                          {t('settings.list.ldap_name')}
                          {isSort && sortColumn === '9' ? <img src={upIcon} alt="" /> : ''}
                          {!isSort && sortColumn === '9' ? <img src={downIcon} alt="" /> : ''}
                        </span>
                      </a>
                    </th>
                    <th className="owner">
                      <a className="sorting_button" data-id="4" onClick={this.onChangeSorting}>
                        <span>
                          {t('settings.list.permission')}
                          {isSort && sortColumn === '4' ? <img src={upIcon} alt="" /> : ''}
                          {!isSort && sortColumn === '4' ? <img src={downIcon} alt="" /> : ''}
                        </span>
                      </a>
                    </th>
                    {this.props.state.user.isSuperAdmin ? (
                      <th>
                        <a className="sorting_button" data-id="5" onClick={this.onChangeSorting}>
                          {t('settings.list.company_name')}
                          {isSort && sortColumn === '5' ? <img src={upIcon} alt="" /> : ''}
                          {!isSort && sortColumn === '5' ? <img src={downIcon} alt="" /> : ''}
                        </a>
                      </th>
                    ) : (
                      <th>
                        <a className="sorting_button" data-id="5" onClick={this.onChangeSorting}>
                          {t('settings.list.assigned_project')}
                          {isSort && sortColumn === '5' ? <img src={upIcon} alt="" /> : ''}
                          {!isSort && sortColumn === '5' ? <img src={downIcon} alt="" /> : ''}
                        </a>
                      </th>
                    )}
                    <th className="created">
                      <a className="sorting_button" data-id="6" onClick={this.onChangeSorting}>
                        <span>
                          {t('settings.list.last_modified')}
                          {isSort && sortColumn === '6' ? <img src={upIcon} alt="" /> : ''}
                          {!isSort && sortColumn === '6' ? <img src={downIcon} alt="" /> : ''}
                        </span>
                      </a>
                    </th>
                    <th className="created">
                      <a className="sorting_button" data-id="7" onClick={this.onChangeSorting}>
                        <span>
                          {t('settings.list.last_accessed')}
                          {isSort && sortColumn === '7' ? <img src={upIcon} alt="" /> : ''}
                          {!isSort && sortColumn === '7' ? <img src={downIcon} alt="" /> : ''}
                        </span>
                      </a>
                    </th>
                    <th>
                      <a className="sorting_button" data-id="8" onClick={this.onChangeSorting}>
                        {t('settings.list.status')}
                        {isSort && sortColumn === '8' ? <img src={upIcon} alt="" /> : ''}
                        {!isSort && sortColumn === '8' ? <img src={downIcon} alt="" /> : ''}
                      </a>
                    </th>
                    <th>&nbsp;</th>
                  </tr>
                </thead>
              </table>
            </div>
          </div>
          {
            !isLoading ? (
              <div>
                {userList.length !== 0
                  ? userList.map((list) => {
                    return (
                      <div key={uuidv4()} className="setting_project_table_wrap">
                        <table className="setting_project_table">
                          <colgroup>
                            <col style={{ width: '36px' }} />
                            <col style={{ width: '7%' }} />
                            <col style={{ width: '13%' }} />
                            <col style={{ width: '13%' }} />
                            <col style={{ width: '8%' }} />
                            <col style={{ width: '8%' }} />
                            <col style={{ width: '11%' }} />
                            <col style={{ width: '11%' }} />
                            <col style={{ width: '11%' }} />
                            <col style={{ width: '8%' }} />
                            <col style={{ width: '' }} />
                          </colgroup>
                          <tbody>
                            <tr>
                              <td>
                                <div className="content_wrapper">
                                  <Checkbox
                                    value={list.uid}
                                    checked={checkValue.indexOf(list.uid) > -1}
                                    onChange={this.handleCheckChange}
                                  />
                                </div>
                              </td>
                              <td>
                                <div className="content_wrapper">
                                  {list.source === 'local' ? (
                                    <Label color="green" horizontal>
                                      {list.source}
                                    </Label>
                                  ) : (
                                    <Label color="pink" horizontal>
                                      {list.source}
                                    </Label>
                                  )}
                                </div>
                              </td>
                              <td className="project_name">
                                <div className="content_wrapper">
                                  {this.getProfileImg(list.uid)}
                                  {list.userName}
                                </div>
                              </td>
                              <td className="project_name">
                                <div className="content_wrapper">
                                  {this.convertToString(list.email)}
                                </div>
                              </td>
                              <td>
                                <div className="content_wrapper owner">
                                  {list.ldapName}
                                </div>
                              </td>
                              <td>
                                <div className="content_wrapper owner">
                                  {`${list.permission.charAt(0).toUpperCase()}${list.permission.slice(
                                    1
                                  )}`}
                                </div>
                              </td>
                              <td>
                                <div className="content_wrapper">
                                  {this.props.state.user.isSuperAdmin && list.companyName}
                                  {!this.props.state.user.isSuperAdmin && list.projectCount === 0
                                    && <span className="number">{list.projectCount}</span>}
                                  {!this.props.state.user.isSuperAdmin && list.projectCount !== 0
                                    && (
                                      <Popup
                                        trigger={(
                                          <span className="number" style={{ cursor: 'pointer' }}>
                                            {list.projectCount}
                                          </span>
                                        )}
                                        on="click"
                                        hideOnScroll
                                        position="bottom left"
                                        style={{ marginLeft: '-16.5px' }}
                                        open={this.state.versionPopup && activeIndex === list.uid}
                                        onOpen={() => {
                                          return this.getSProjectVersionDetail(list.uid);
                                        }}
                                        onClose={this.handleClose}
                                      >
                                        <List>
                                          {this.state.versionList.map((item) => {
                                            return (
                                              <List.Item key={uuidv4()}>
                                                <List.Icon name="folder" />
                                                <List.Content>{item}</List.Content>
                                              </List.Item>
                                            );
                                          })}
                                        </List>
                                      </Popup>
                                    )}
                                </div>
                              </td>
                              <td>
                                <div className="content_wrapper created">
                                  <span>{list.lastModified}</span>
                                </div>
                              </td>
                              <td>
                                <div className="content_wrapper created">
                                  <span>{list.lastAccessed}</span>
                                </div>
                              </td>
                              <td>
                                <div className="content_wrapper">
                                  <span className="number">
                                    {`${list.status.charAt(0).toUpperCase()}${list.status.slice(1)}`}
                                  </span>
                                </div>
                              </td>
                              <td>
                                <div className="content_wrapper">
                                  <a
                                    className="edit_button"
                                    onClick={() => {
                                      this.handleMEUOpen(list.uid);
                                    }}
                                    style={{ cursor: 'pointer' }}
                                  >
                                    {t('system.button.edit')}
                                  </a>
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    );
                  })
                  : null}
                {error && <div className="error_log">{error}</div>}
                {isNextLoading && <Loader active={isNextLoading} size="medium">{t('list.title.loading')}</Loader>}
              </div>
            ) : (
              <div>
                <Segment>
                  <Dimmer active inverted>
                    <Loader size="large">{t('list.title.loading')}</Loader>
                  </Dimmer>
                </Segment>
              </div>
            )
          }
        </div>
        <ChangeStatusProject
          isOpenMCS={this.state.isOpenMCS}
          closeModal={this.handleMCSClose}
          rowData={this.state.selectedList}
          location={pathname}
          completeCallback={this.handleCompleteCallback}
          translate={t}
        />
        <EditUserModal
          isOpenMEU={this.state.isOpenMEU}
          closeModal={this.handleMEUClose}
          userId={this.state.selectedUserId}
          location={pathname}
          completeCallback={this.handleCompleteCallback}
          translate={t}
        />
        <DeleteProjectModal
          isOpenMDP={this.state.isOpenMDP}
          closeModal={this.handleMDUClose}
          data={checkValue}
          location={pathname}
          completeCallback={this.handleCompleteCallback}
          translate={t}
        />
        <NewUserModal
          isOpenMCU={this.state.isOpenMCU}
          closeModal={this.handleMCUClose}
          completeCallback={this.handleCompleteCallback}
          translate={t}
        />
        <AssigningProjectModal
          isOpenMAP={this.state.isOpenMAP}
          isOpenMCU={this.state.isOpenMCU}
          closeModal={this.handleMAPClose}
          selectedUsers={this.state.selectedList}
          completeCallback={this.handleCompleteCallback}
          translate={t}
        />
        <Modal open={this.state.isOpen} onClose={this.closeErrorModal}>
          <div className="modal_popup_wrap">
            <div className="modal_popup_box">
              <div className="modal_popup">
                <h2 className="title">{t('modal.title.attention')}</h2>
                <p className="text">{t('modal.message.select_one_user')}</p>
                <div className="button_wrap">
                  <a
                    className="center_button"
                    onClick={this.closeErrorModal}
                    style={{ cursor: 'pointer' }}
                  >
                    {t('modal.button.ok')}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}

export default WithRouter(withTranslation()(inject('state')(observer(UserSetting))));
